/*
 * File: useGetHomePageData.ts
 * Author: Austin Robinson
 * Date Created: 2/11/2024
 * Copyright (c) DrivingDoc 2023
 */
import { createQuery } from 'react-query-kit';

import { publicApi } from 'api';

export type GetSchoolInfoResult = {
  name: string;
  short_name?: string;
  mission_statement?: string;
  logo_image?: string;
  banner_image?: string;
  login_image?: string;
  about: {
    title?: string;
    subtitle?: string;
    banner_image?: string;
    main_section_title?: string;
    main_section_content?: string;
    main_section_image?: string;
    subsections?: {
      title: string;
      content: string;
    }[];
    team?: {
      name: string;
      title?: string;
      photo?: string;
      bio?: {
        content?: string;
      };
    }[];
  };
  locations?: {
    id: string;
    name: string;
    description?: string;
    street_address?: string;
    city?: string;
    state?: string;
    zip?: string;
    phone?: string;
    email?: string;
  }[];
  testimonials?: {
    id: string;
    author: string;
    authorSubtitle?: string;
    content: string;
    rating?: number;
  }[];
};

async function getSchoolInfo(): Promise<GetSchoolInfoResult> {
  // make api call
  const result = await publicApi.get('/public/info');

  // return the data object
  return result.data as GetSchoolInfoResult;
}

const useGetSchoolInfo = createQuery({
  queryKey: ['schoolInfo'],
  fetcher: getSchoolInfo,
});

export { useGetSchoolInfo };
